import React from 'react';
import Box from '../../../../components/Box';
import { Helpers } from '../../../../helpers/Helpers';
import { KTCard } from '../../../../_metronic/helpers/components/KTCard';
import { KTCardBody } from '../../../../_metronic/helpers/components/KTCardBody';

interface Props {
    technicalInformationRef: any
    netWeight: string | undefined
    setNetWeight: React.Dispatch<React.SetStateAction<string | undefined>>
    width: string | undefined
    setWidth: React.Dispatch<React.SetStateAction<string | undefined>>
    volume: string | undefined
    setVolume: React.Dispatch<React.SetStateAction<string | undefined>>
    desi: string | undefined,
    setDesi: React.Dispatch<React.SetStateAction<string | undefined>>
    loadedWeight: string | undefined
    setLoadedWeight: React.Dispatch<React.SetStateAction<string | undefined>>
    height: string | undefined
    setHeight: React.Dispatch<React.SetStateAction<string | undefined>>
    gearboxType: boolean | undefined
    setGearboxType: React.Dispatch<React.SetStateAction<boolean | undefined>>
    tacometerType: boolean | undefined
    setTacometerType: React.Dispatch<React.SetStateAction<boolean | undefined>>
    aksCount: string | undefined
    setAksCount: React.Dispatch<React.SetStateAction<string | undefined>>
    height2: string | undefined
    setHeight2: React.Dispatch<React.SetStateAction<string | undefined>>
}

const TechnicalInformation = ({
    technicalInformationRef,
    netWeight,
    setNetWeight,
    width,
    setWidth,
    volume,
    setVolume,
    desi,
    setDesi,
    loadedWeight,
    setLoadedWeight,
    height,
    setHeight,
    gearboxType,
    setGearboxType,
    tacometerType,
    setTacometerType,
    aksCount,
    setAksCount,
    height2,
    setHeight2
}: Props) => {
    return (
        <div className='containerPart' ref={technicalInformationRef}>
            <KTCard className="ebbe-card mt-10">
                <KTCardBody>
                    <h4 className="mb-10 text-black">Teknik Bilgileri</h4>

                    <div className='row'>
                        <div className="col-md-4">
                            <div>
                                <label htmlFor="exampleFormControlInput1" className="form-label">Net Ağırlığı (kg)</label>
                                <input style={{ border: '1px solid #F1F1F4' }} value={netWeight} onChange={(e) => setNetWeight(e.target.value)} type="number" className="form-control form-control-solid" />
                            </div>

                            <div className="mt-5">
                                <label htmlFor="exampleFormControlInput1" className="form-label">En (cm)</label>
                                <input style={{ border: '1px solid #F1F1F4' }} value={width} onChange={(e) => setWidth(e.target.value)} type="number" className="form-control form-control-solid" />
                            </div>

                            <div className="mt-5">
                                <label htmlFor="exampleFormControlInput1" className="form-label">Hacim (m<sup>3</sup>)</label>
                                <input style={{ border: '1px solid #F1F1F4' }} value={volume} onChange={(e) => setVolume(e.target.value)} type="number" className="form-control form-control-solid" />
                            </div>

                            <div className="mt-5">
                                <label htmlFor="exampleFormControlInput1" className="form-label">Desi (m<sup>3</sup>)</label>
                                <input style={{ border: '1px solid #F1F1F4' }} value={desi} onChange={(e) => setDesi(e.target.value)} type="number" className="form-control form-control-solid" />
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div>
                                <label htmlFor="exampleFormControlInput1" className="form-label">Azami Yüklü Ağırlığı (kg)</label>
                                <input style={{ border: '1px solid #F1F1F4' }} value={loadedWeight} onChange={(e) => setLoadedWeight(e.target.value)} type="number" className="form-control form-control-solid" />
                            </div>

                            <div className="mt-5">
                                <label htmlFor="exampleFormControlInput1" className="form-label">Boy (cm)</label>
                                <input style={{ border: '1px solid #F1F1F4' }} value={height} onChange={(e) => setHeight(e.target.value)} type="number" className="form-control form-control-solid" />
                            </div>

                            <div className='mt-5'>
                                <label htmlFor="exampleFormControlInput1" className="form-label">Şanzıman Tipi</label>

                                <Box flexDirection='row' height='42px'>
                                    <Box flex={1} justifyContent='center'>
                                        <div className="form-check form-check-custom form-check-solid d-flex">
                                            <input onChange={(e) => { setGearboxType(Helpers.isEmpty(gearboxType) || gearboxType == false ? true : undefined) }} className="form-check-input" type="checkbox" value="" id={"gearboxTypeYes"} checked={!Helpers.isEmpty(gearboxType) && gearboxType == true} />
                                            <label className="form-check-label" htmlFor={"gearboxTypeYes"}>
                                                Otomatik
                                            </label>
                                        </div>
                                    </Box>
                                    <Box flex={1} justifyContent='center'>
                                        <div className="form-check form-check-custom form-check-solid d-flex">
                                            <input onChange={(e) => { setGearboxType(Helpers.isEmpty(gearboxType) || gearboxType == true ? false : undefined) }} className="form-check-input" type="checkbox" value="" id={"gearboxTypeNo"} checked={!Helpers.isEmpty(gearboxType) && gearboxType == false} />
                                            <label className="form-check-label" htmlFor={"gearboxTypeNo"}>
                                                Manuel
                                            </label>
                                        </div>
                                    </Box>
                                </Box>
                            </div>

                            <div className='mt-5'>
                                <label htmlFor="exampleFormControlInput1" className="form-label">Takometre Tipi</label>

                                <Box flexDirection='row' height='42px'>
                                    <Box flex={1} justifyContent='center'>
                                        <div className="form-check form-check-custom form-check-solid d-flex">
                                            <input onChange={(e) => { setTacometerType(Helpers.isEmpty(tacometerType) || tacometerType == false ? true : undefined) }} className="form-check-input" type="checkbox" value="" id={"tacometerTypeYes"} checked={!Helpers.isEmpty(tacometerType) && tacometerType == true} />
                                            <label className="form-check-label" htmlFor={"tacometerTypeYes"}>
                                                Dijital
                                            </label>
                                        </div>
                                    </Box>
                                    <Box flex={1} justifyContent='center'>
                                        <div className="form-check form-check-custom form-check-solid d-flex">
                                            <input onChange={(e) => { setTacometerType(Helpers.isEmpty(tacometerType) || tacometerType == true ? false : undefined) }} className="form-check-input" type="checkbox" value="" id={"tacometerTypeNo"} checked={!Helpers.isEmpty(tacometerType) && tacometerType == false} />
                                            <label className="form-check-label" htmlFor={"tacometerTypeNo"}>
                                                Analog
                                            </label>
                                        </div>
                                    </Box>
                                </Box>
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div>
                                <label htmlFor="exampleFormControlInput1" className="form-label">Aks Sayısı</label>
                                <input style={{ border: '1px solid #F1F1F4' }} value={aksCount} onChange={(e) => setAksCount(e.target.value)} type="number" className="form-control form-control-solid" />
                            </div>

                            <div className="mt-5">
                                <label htmlFor="exampleFormControlInput1" className="form-label">Yükseklik (cm)</label>
                                <input style={{ border: '1px solid #F1F1F4' }} value={height2} onChange={(e) => setHeight2(e.target.value)} type="number" className="form-control form-control-solid" />
                            </div>
                        </div>
                    </div>
                </KTCardBody>
            </KTCard>
        </div>
    )
}

export default TechnicalInformation;